export default __webpack_public_path__ + "static/media/p1.3273da19.jpg";